<template>
  <svg width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3.5 9.5h-3v5h3v-5zM9.5 5.5h-3v9h3v-9zM15.5 1.5h-3v13h3v-13z"
      stroke="currentColor"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
